import React from 'react'
import PropTypes from 'prop-types'
import './Carousel.scss'

const Carousel = ({children}) => {
    return (
        <div className="carousel">
            <div className="carousel-track">
                <div className={'carousel-track-group'}>
                    {React.Children.map(children, (item, index) => (
                        <div key={index} className="carousel-item">
                            {React.cloneElement(item, {})}
                        </div>
                    ))}
                </div>
                <div className={'carousel-track-group'} aria-hidden="true">
                    {React.Children.map(children, (item, index) => (
                        <div key={`${index}-hidden`} className="carousel-item" aria-hidden="true">
                            {React.cloneElement(item, {})}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Carousel

Carousel.propTypes = {
    showButtons: PropTypes.bool,
    speed: PropTypes.number,
}

Carousel.defaultProps = {
    showButtons: false,
}
